import * as React from 'react';
import { ModalWindow } from '@cian/ui-kit';
import { useIsDesktop } from '@cian/valuation-utils-component';

export interface IDemandRequestModalProps extends React.PropsWithChildren {
  title: string;
  isOpen: boolean;

  onClose(): void;
}

export const DemandRequestModal: React.FC<IDemandRequestModalProps> = ({ children, isOpen, onClose, title }) => {
  const isDesktop = useIsDesktop();

  return (
    <ModalWindow
      title={title}
      open={isOpen}
      onClose={onClose}
      width={448}
      content={children}
      size={isDesktop ? 'XS' : 'M'}
    />
  );
};

DemandRequestModal.displayName = 'DemandRequestModal';
